export default "__VITE_ASSET___n$gjxvw__"